import React, { useState, useEffect } from "react";
import Marquee from "react-fast-marquee";
import { Skeleton } from "@/components/ui/skeleton";

const TITLES = [
  "WEF", "CA", "UCT", "RUSI", "Vive", "Cortex",
  "Journey", "CDE", "Uplink", "FX", "SweepSouth",
  "CDOE", "MOHARA", "SAA"
];

function LogoMarquee({ speed = 50 }) {
  const [loadedImages, setLoadedImages] = useState({});
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Add a small delay before showing the marquee to ensure smooth transition
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 600);

    return () => clearTimeout(timer);
  }, []);

  const getImageSrc = (title) => {
    try {
      const imageUrl = new URL(`../../Assets/ScrollImages/${title}.png`, import.meta.url).href;
      return imageUrl;
    } catch (error) {
      console.error(`Error creating URL for image: ${title}.png`, error);
      return "";
    }
  };

  const handleImageLoad = (title) => {
    setLoadedImages(prev => ({ ...prev, [title]: true }));
  };

  return (
    <div className={`flex w-full mx-auto transition-opacity duration-1000 ${
      isVisible ? 'opacity-100' : 'opacity-0'
    }`}>
      <Marquee gradient={true} gradientWidth={100} autoFill={true} speed={speed}>
        {TITLES.map((title) => (
          <div
            key={title}
            className="relative"
            style={{ width: 120, height: 120, marginRight: "120px" }}
          >
            {!loadedImages[title] && (
              <Skeleton 
                className="absolute inset-0 m-[10px]"
              />
            )}
            <img
              src={getImageSrc(title)}
              style={{ 
                width: 120, 
                height: 120, 
                padding: "10px",
                opacity: loadedImages[title] ? 1 : 0,
                transition: "opacity 0.3s ease-in-out"
              }}
              alt={`${title} logo`}
              onLoad={() => handleImageLoad(title)}
              onError={(e) => {
                e.target.style.display = 'none';
                console.warn(`Failed to load image: ${title}.png`);
              }}
            />
          </div>
        ))}
      </Marquee>
    </div>
  );
}

export default LogoMarquee; 